/**
 * 获取url中的参数
 * @param url 
 * @param key 参数名
 * @returns 
 */
export function getUrlParams(url: string, key: string): string {
  if (!/^http/.test(url)) {
    url = 'http://' + url
  }
  const search = new URL(url).search;  
  const params = new URLSearchParams(search);  
  return decodeURIComponent(params.get(key) || '');  
}  

/**
 * 睡眠函数
 * @param duration 时长默认1000ms
 */
export function sleep(duration = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, duration);
  });
}